import { Content, Loading } from 'components'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'
import React from 'react'

import { useBlog } from '../blogs.services'

export const Blogs = () => {
  const router = useRouter()
  const { slug } = router.query
  const blog_slug = typeof slug === 'string' ? slug : ''

  const { data: blogData, isLoading } = useBlog(blog_slug)

  if (isLoading) {
    return <Loading centerParent />
  }

  if (!blogData) {
    return <p>Something went wrong!!</p>
  }

  return (
    <div>
      <NextSeo
        title={`${blogData.title} - Blog | Devsnest`}
        openGraph={{
          images: [{ url: blogData.banner }]
        }}
      />
      <Content
        content={blogData.content}
        title={blogData.title}
        author={blogData.author}
        bannerSrc={blogData.banner}
        category={blogData.category}
        created_at={blogData.created_at}
        updated_at={blogData.updated_at}
      />
    </div>
  )
}

Blogs.layout = {
  pageClassName: 'max-w-4xl px-3 py-5'
}
